import { blogCustomSendingDomainService } from '../services'

const state = {
    loading: false,
    customDomain: {
        details: {
            sending_dns_records: [],
            receiving_dns_records: [],
        },
        verified: null,
    },
}

const actions = {

    get({ dispatch, commit }) {
        commit('startRequest')
        return blogCustomSendingDomainService.get().then(
            response => {
                commit('getRequestSuccess', response)
                return response
            },
            error => {
                commit('endRequest')
                dispatch('alert/error', 'Unable to get custom domain settings: ' + error, { root: true })
            }
        )
    },
    connect({ dispatch, commit }, params) {
        commit('startRequest')
        return blogCustomSendingDomainService.connect(params).then(
            response => {
                commit('getRequestSuccess', response)
                return response
            },
            error => {
                commit('endRequest')
                dispatch('alert/error', 'We were unable to setup the custom domain settings: ' + error, { root: true })
            }
        )
    },
    verify({ dispatch, commit }, domainName) {
        commit('startRequest')
        return blogCustomSendingDomainService.verify(domainName).then(
            response => {
                commit('getRequestSuccess', response)
                return response
            },
            error => {
                dispatch('alert/error', 'We were unable to verify the custom domain settings: ' + error, { root: true })
            }
        )
    },
    disconnect({ dispatch, commit }) {
        commit('startRequest')
        return blogCustomSendingDomainService.disconnect().then(
            response => {
                commit('getRequestSuccess', response)
                return response
            },
            error => {
                commit('endRequest')
                dispatch('alert/error', 'We were unable to disconnect the custom domain settings: ' + error, { root: true })
            }
        )
    },
}

const mutations = {
    startRequest (state) {
        state.loading = true
    },
    endRequest (state) {
        state.loading = false
    },
    getRequestSuccess (state, data) {
        state.customDomain = data.customDomain
        state.loading = false
    },
    getRequestError (state, data) {
        state.customDomain = data.customDomain
        state.loading = false
    },
}

const getters = {
    isBusy (state) {
        return state.loading === true
    },
    getCustomSendingDomain (state) {
        return state.customDomain
    },
}


export const blogCustomSendingDomainModule = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
